import { postData } from "../../shared/utils";

export function snapshotRequestUpdate() {
  return {
    updateSnapshotRequest(body) {
      postData(`/snapshot_requests/toggle_exclude`, body);
    },
  };
}
